// Only PaymentPlans still reads and writes this store; WL-3009 retires it.
export type PatientsStore = {
  patient?: PatientWithClaimMessage;
  claims: ClaimWithProcedureAndPatientMessage[];
};

export const initialPatientStore: PatientsStore = {
  patient: undefined,
  claims: [],
};

export type PatientsStoreAction =
  | { type: "SET_PATIENT"; patient?: PatientWithClaimMessage }
  | { type: "SET_CLAIMS"; claims: ClaimWithProcedureAndPatientMessage[] };

export function patientsStoreReducer(
  store: PatientsStore,
  action: PatientsStoreAction,
): PatientsStore {
  switch (action.type) {
    case "SET_PATIENT":
      return { ...store, patient: action.patient };

    case "SET_CLAIMS":
      return { ...store, claims: action.claims };

    default:
      return store;
  }
}
